import React from "react";

import Paper from '@mui/material/Paper';
import Moment from 'react-moment';
import { calendarStrings } from '../../services/calendarStrings';

import { ViewState, EditingState } from '@devexpress/dx-react-scheduler';
import moment from "moment";
import {
    Scheduler,
    DayView,
    WeekView,
    Appointments,
    AllDayPanel,
    Toolbar,
    DateNavigator,
    AppointmentForm
} from '@devexpress/dx-react-scheduler-material-ui';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import Create from '@mui/icons-material/Create';
import TextField from '@mui/material/TextField';
import CalendarToday from '@mui/icons-material/CalendarToday';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { createEvent, updateEvent, deleteEvent } from "../../data/loca/events";
import Notes from '@mui/icons-material/Notes';
import Button from '@mui/material/Button';
import { connectProps } from '@devexpress/dx-react-core';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CircularProgress from '@mui/material/CircularProgress';

const PREFIX = 'Demo';

const classes = {
    content: `${PREFIX}-content`,
    header: `${PREFIX}-header`,
    closeButton: `${PREFIX}-closeButton`,
    buttonGroup: `${PREFIX}-buttonGroup`,
    button: `${PREFIX}-button`,
    picker: `${PREFIX}-picker`,
    wrapper: `${PREFIX}-wrapper`,
    icon: `${PREFIX}-icon`,
    textField: `${PREFIX}-textField`,
    addButton: `${PREFIX}-addButton`,
};
const StyledDiv = styled('div')(({ theme }) => ({
    [`& .${classes.icon}`]: {
        margin: theme.spacing(2, 0),
        marginRight: theme.spacing(2),
    },
    [`& .${classes.header}`]: {
        overflow: 'hidden',
        paddingTop: theme.spacing(0.5),
    },
    [`& .${classes.textField}`]: {
        width: '100%',
    },
    [`& .${classes.content}`]: {
        padding: theme.spacing(2),
        paddingTop: 0,
    },
    [`& .${classes.closeButton}`]: {
        float: 'right',
    },
    [`& .${classes.picker}`]: {
        marginRight: theme.spacing(2),
        '&:last-child': {
            marginRight: 0,
        },
        width: '50%',
    },
    [`& .${classes.wrapper}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(1, 0),
    },
    [`& .${classes.buttonGroup}`]: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 2),
    },
    [`& .${classes.button}`]: {
        marginLeft: theme.spacing(2),
    },
}));

const CalendarOverlayContainer = React.forwardRef(({ children, className, ...restProps }, ref) => (
    <div ref={ref} className={`calendar-overlay-container ${className || ''}`} {...restProps}>
        {children}
    </div>
));
class AppointmentFormContainerBasic extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            appointmentChanges: {},
            isCommitting: false,
            committingAction: null,
            commitError: null,
        };

        this.getAppointmentData = () => {
            const { appointmentData } = this.props;
            return appointmentData;
        };
        this.getAppointmentChanges = () => {
            const { appointmentChanges } = this.state;
            return appointmentChanges;
        };

        this.changeAppointment = this.changeAppointment.bind(this);
        this.commitAppointment = this.commitAppointment.bind(this);
    }

    changeAppointment({ field, changes }) {
        const nextChanges = {
            ...this.getAppointmentChanges(),
            [field]: changes,
        };
        this.setState({
            appointmentChanges: nextChanges,
        });
    }

    async commitAppointment(type) {
        if (this.state.isCommitting) {
            return;
        }
        const { commitChanges } = this.props;
        const appointment = {
            ...this.getAppointmentData(),
            ...this.getAppointmentChanges(),
        };

        this.setState({ isCommitting: true, committingAction: type, commitError: null });

        try {
            if (type === 'deleted') {
                await deleteEvent(appointment.id);
                commitChanges({ [type]: appointment.id });
            } else if (type === 'changed') {
                await updateEvent(appointment, appointment.id);
                commitChanges({ [type]: { [appointment.id]: appointment } });
            } else {
                const createdAppointments = await createEvent(appointment);
                if (Array.isArray(createdAppointments) && createdAppointments.length > 0) {
                    createdAppointments.forEach((createdAppointment) => {
                        commitChanges({
                            [type]: {
                                ...createdAppointment,
                                type: 'others',
                                color: '#4C566A',
                                startDate: new Date(createdAppointment.startDate),
                                endDate: new Date(createdAppointment.endDate),
                            },
                        });
                    });
                } else {
                    commitChanges({ [type]: appointment });
                }
            }
            this.setState({
                appointmentChanges: {},
            });
            this.props.visibleChange();
        } catch (error) {
            console.error(error);
            this.setState({
                commitError: "Impossible d'enregistrer l'événement. Vérifiez la configuration Google Calendar puis réessayez.",
            });
        } finally {
            this.setState({ isCommitting: false, committingAction: null });
        }
    }

    render() {
        const {
            visible,
            visibleChange,
            appointmentData,
            cancelAppointment,
            target,
            onHide,
        } = this.props;
        const { appointmentChanges, isCommitting, committingAction, commitError } = this.state;

        const displayAppointmentData = {
            ...appointmentData,
            ...appointmentChanges,
        };

        const isNewAppointment = appointmentData.id === undefined;
        const isEditable = appointmentData.type === "others";
        const isNow = appointmentData.type === "now";
        const applyChanges = isNewAppointment
            ? () => this.commitAppointment('added')
            : () => this.commitAppointment('changed');

        const textEditorProps = field => ({
            variant: 'outlined',
            onChange: (event) => this.changeAppointment({
                field: [field], changes: event.target.value,
            }),
            value: displayAppointmentData[field] || '',
            label: field[0].toUpperCase() + field.slice(1),
            className: classes.textField,
            disabled: isCommitting,
        });

        const pickerEditorProps = field => ({
            // keyboard: true,
            value: displayAppointmentData[field],
            onChange: date => this.changeAppointment({
                field: [field], changes: date ? date.toDate() : new Date(displayAppointmentData[field]),
            }),
            ampm: false,
            inputFormat: 'DD/MM/YYYY HH:mm',
            onError: () => null,
            disabled: isCommitting,
        });
        const startDatePickerProps = pickerEditorProps('startDate');
        const endDatePickerProps = pickerEditorProps('endDate');
        const recurrenceEndPickerProps = pickerEditorProps('recurrenceEndDate');
        const cancelChanges = () => {
            if (isCommitting) {
                return;
            }
            this.setState({
                appointmentChanges: {},
                commitError: null,
            });
            visibleChange();
            cancelAppointment();
        };
        let edit = true;
        if (!isNewAppointment && !isEditable && !isNow) {
            edit = false;
        }
        return (
            <>
                <AppointmentForm.Overlay
                    visible={visible && edit && !isNow}
                    target={target}
                    fullSize
                    onHide={isCommitting ? () => {} : onHide}
                >
                    <StyledDiv>
                        <div className={classes.header}>
                            <IconButton className={classes.closeButton} onClick={cancelChanges} size="large">
                                <Close color="action" />
                            </IconButton>
                        </div>
                        <div className={classes.content}>
                            <div className={classes.wrapper}>
                                <Create className={classes.icon} color="action" />
                                <div className={classes.textField}>
                                    <Typography variant="h6" gutterBottom>
                                        Ajouter un évènement
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" gutterBottom>
                                        Les évènements servent à bloquer des créneaux pour éviter d’ajouter une location sur la même plage horaire.
                                    </Typography>
                                    <TextField
                                        {...textEditorProps('title')}
                                        autoFocus
                                    />
                                </div>
                            </div>
                            <div className={classes.wrapper}>
                                <CalendarToday className={classes.icon} color="action" />

                                <LocalizationProvider dateAdapter={AdapterMoment}>


                                    <DateTimePicker
                                        label="Date de début"
                                        renderInput={
                                            props => <TextField className={classes.picker} {...props} />
                                        }
                                        {...startDatePickerProps}
                                    />
                                    <DateTimePicker
                                        label="Date de fin"
                                        renderInput={
                                            props => <TextField className={classes.picker} {...props} />
                                        }
                                        {...endDatePickerProps}
                                    />

                                </LocalizationProvider>
                            </div>
                            {isNewAppointment && (
                                <>
                                    <div className={classes.wrapper}>
                                        <div style={{ width: '100%' }}>
                                            <FormControlLabel
                                                control={(
                                                    <Checkbox
                                                        disabled={isCommitting}
                                                        checked={Boolean(displayAppointmentData.repeatWeekly)}
                                                        onChange={(event) => {
                                                            const checked = event.target.checked;
                                                            this.changeAppointment({
                                                                field: 'repeatWeekly',
                                                                changes: checked,
                                                            });

                                                            if (
                                                                checked
                                                                && !displayAppointmentData.recurrenceEndDate
                                                                && displayAppointmentData.startDate
                                                            ) {
                                                                this.changeAppointment({
                                                                    field: 'recurrenceEndDate',
                                                                    changes: moment(displayAppointmentData.startDate).add(4, 'weeks').toDate(),
                                                                });
                                                            }
                                                        }}
                                                    />
                                                )}
                                                label="Répéter toutes les semaines (même jour et même heure)"
                                            />
                                        </div>
                                    </div>
                                    {displayAppointmentData.repeatWeekly && (
                                        <div className={classes.wrapper}>
                                            <CalendarToday className={classes.icon} color="action" />
                                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                                <DateTimePicker
                                                    label="Répéter jusqu'au"
                                                    renderInput={
                                                        props => <TextField className={classes.textField} {...props} />
                                                    }
                                                    {...recurrenceEndPickerProps}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                    )}
                                </>
                            )}
                            <div className={classes.wrapper}>
                                <Notes className={classes.icon} color="action" />
                                <TextField
                                    {...textEditorProps('notes')}
                                    multiline
                                    rows="6"
                                />
                            </div>
                        </div>
                        <div className={classes.buttonGroup}>
                            {(!isNewAppointment && isEditable) && (
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    className={classes.button}
                                    disabled={isCommitting}
                                    startIcon={committingAction === 'deleted' ? <CircularProgress size={16} /> : null}
                                    onClick={() => {
                                        this.commitAppointment('deleted');
                                    }}
                                >
                                    {committingAction === 'deleted' ? 'Suppression...' : 'Supprimer'}
                                </Button>
                            )}
                            {(isNewAppointment || isEditable) && (
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    className={classes.button}
                                    disabled={isCommitting}
                                    startIcon={committingAction === (isNewAppointment ? 'added' : 'changed') ? <CircularProgress size={16} /> : null}
                                    onClick={() => {
                                        applyChanges();
                                    }}
                                >

                                    {committingAction === (isNewAppointment ? 'added' : 'changed') ? (isNewAppointment ? 'Création...' : 'Enregistrement...') : (isNewAppointment ? 'Créer' : 'Enregistrer')}
                                </Button>
                            )}
                        </div>
                        {commitError && (
                            <Typography color="error" variant="body2" className={classes.content}>
                                {commitError}
                            </Typography>
                        )}
                    </StyledDiv>
                </AppointmentForm.Overlay>

                <AppointmentForm.Overlay
                    visible={visible && !edit && !isNow}
                    target={target}
                    fullSize
                    onHide={onHide}
                >
                    <StyledDiv>
                        <div className={classes.header}>

                            <IconButton className={classes.closeButton} onClick={cancelChanges} size="large">
                                <Close color="action" />
                            </IconButton>
                        </div>
                        <div className={classes.content}>
                            <div className={classes.wrapper}>
                               🛠️ {appointmentData.title}
                                
                            </div>
                            <div className={classes.wrapper}>
                                <div>📅
                                <Moment locale="fr" calendar={calendarStrings}>
                                    {new Date(appointmentData.startDate)}
                                    </Moment>
                                </div>
                            </div>
                            <div className={classes.wrapper}>
                                <div>🔗<a href={appointmentData.link}>{appointmentData.linkLabel || "Se rendre sur la page de location"}</a></div>
                            </div>
                            {appointmentData.notes && (
                                <div className={classes.wrapper}>
                                    <Notes className={classes.icon} color="action" />
                                    <div>{appointmentData.notes}</div>
                                </div>
                            )}
                        </div>
                       
                    </StyledDiv>
                </AppointmentForm.Overlay>
            </>
            
        );
    }
}

export default class BookCalendar extends React.PureComponent {

    buildAppointments(props) {
        let appointments = [];

        const toLocalDate = (value) => {
            if (!value) return value;
            if (value instanceof Date) return new Date(value.getTime());
            const parsed = moment.parseZone(value);
            if (!parsed.isValid()) return new Date(value);
            return new Date(
                parsed.year(),
                parsed.month(),
                parsed.date(),
                parsed.hour(),
                parsed.minute(),
                parsed.second(),
                parsed.millisecond(),
            );
        };

        const rentalEventDurationMinutes = Math.max(5, Number(props.rentalEventDurationMinutes || 30));
        const rentalDeliveryEventDurationMinutes = Math.max(5, Number(props.rentalDeliveryEventDurationMinutes || 60));
        const rentalDeliveryWithSetupEventDurationMinutes = Math.max(5, Number(props.rentalDeliveryWithSetupEventDurationMinutes || 120));
        const rentalPickupEventDurationMinutes = Math.max(5, Number(props.rentalPickupEventDurationMinutes || 60));
        const getStartEventDuration = (delivery) => {
            if (delivery === "NoDelivery") {
                return rentalEventDurationMinutes;
            }
            if (delivery === "DeliveryWithPickupAndSetup") {
                return rentalDeliveryWithSetupEventDurationMinutes;
            }
            if (delivery === "DeliveryWithPickup" || delivery === "DeliveryOnly") {
                return rentalDeliveryEventDurationMinutes;
            }
            return rentalEventDurationMinutes;
        };
        const getEndEventDuration = (delivery) => {
            if (delivery === "NoDelivery") {
                return rentalEventDurationMinutes;
            }
            if (delivery === "DeliveryWithPickupAndSetup") {
                return rentalDeliveryWithSetupEventDurationMinutes;
            }
            if (delivery === "DeliveryWithPickup" || delivery === "PickupOnly") {
                return rentalPickupEventDurationMinutes;
            }
            return rentalEventDurationMinutes;
        };
        const isRenterPickupStartEvent = (delivery) => delivery === "NoDelivery" || delivery === "PickupOnly";
        const isRenterReturnEndEvent = (delivery) => delivery === "NoDelivery" || delivery === "DeliveryOnly";
        const getEndEventTitle = (rental, delivery) => `${isRenterReturnEndEvent(delivery) ? '🚗 ' : '↩ '}${rental.toolName}`;
        const addRentalAppointment = (rental, suffix, anchorDate, title, color, durationMinutes, startsAtAnchor = false) => {
            const appointmentStart = startsAtAnchor ? anchorDate : moment(anchorDate).add(-durationMinutes, 'm').toDate();
            const appointmentEnd = moment(anchorDate).add(durationMinutes, 'm').toDate();
            appointments.push({
                id: rental.id + suffix,
                link: "/" + rental.id,
                color,
                title,
                type: "rental",
                startDate: appointmentStart,
                endDate: appointmentEnd
            });
        };

        if (props.events) {
            appointments = props.events.map(event => ({
                ...event,
                startDate: toLocalDate(event.startDate),
                endDate: toLocalDate(event.endDate),
            }));
        }

        const now = new Date();
        const nowStart = moment(now).add(0, 'm').toDate();
        const nowEnd = moment(now).add(5, 'm').toDate();
        appointments.push({ id: 'now', color: "black", title: '', type: "now", startDate: nowStart, endDate: nowEnd });

        const rentals = JSON.parse(localStorage.getItem("activeRentals") || "[]");
        rentals.forEach(rental => {
            let start = toLocalDate(rental.startDate);
            let ret = toLocalDate(rental.endDate);
            const delivery = rental.delivery || "NoDelivery";

            addRentalAppointment(rental, "st", start, rental.toolName, (rental.inDelivery ? "#005d6c" : "#00043c"), getStartEventDuration(delivery), isRenterPickupStartEvent(delivery));

            addRentalAppointment(rental, "ed", ret, getEndEventTitle(rental, delivery), "#3C0004", getEndEventDuration(delivery), isRenterReturnEndEvent(delivery));
        });

        return appointments;
    }

    constructor(props) {
        super(props);

        const appointments = this.buildAppointments(props);

        this.state = {
            data: appointments,
            confirmationVisible: false,
            editingFormVisible: false,
            deletedAppointmentId: undefined,
            editingAppointment: undefined,
            previousAppointment: undefined,
            addedAppointment: {},
            startDayHour: 8,
            endDayHour: 22,
            isNewAppointment: false,
        };

        this.toggleConfirmationVisible = this.toggleConfirmationVisible.bind(this);
        this.commitDeletedAppointment = this.commitDeletedAppointment.bind(this);
        this.toggleEditingFormVisibility = this.toggleEditingFormVisibility.bind(this);

        this.commitChanges = this.commitChanges.bind(this);
        this.onEditingAppointmentChange = this.onEditingAppointmentChange.bind(this);
        this.onAddedAppointmentChange = this.onAddedAppointmentChange.bind(this);
        this.refreshAppointments = this.refreshAppointments.bind(this);
        this.handleStorageUpdate = this.handleStorageUpdate.bind(this);
        this.handleAppointmentDoubleClick = this.handleAppointmentDoubleClick.bind(this);
        this.appointmentForm = connectProps(AppointmentFormContainerBasic, () => {
            const {
                editingFormVisible,
                editingAppointment,
                data,
                addedAppointment,
                isNewAppointment,
                previousAppointment,
            } = this.state;

            const currentAppointment = data
                .filter(appointment => editingAppointment && appointment.id === editingAppointment.id)[0]
                || addedAppointment;
            const cancelAppointment = () => {
                if (isNewAppointment) {
                    this.setState({
                        editingAppointment: previousAppointment,
                        isNewAppointment: false,
                    });
                }
            };

            return {
                visible: editingFormVisible,
                appointmentData: currentAppointment,
                commitChanges: this.commitChanges,
                visibleChange: this.toggleEditingFormVisibility,
                onEditingAppointmentChange: this.onEditingAppointmentChange,
                cancelAppointment,
            };
        });
    }

componentDidMount() {
    window.addEventListener("active-rentals-updated", this.refreshAppointments);
    window.addEventListener("storage", this.handleStorageUpdate);
}

componentWillUnmount() {
    window.removeEventListener("active-rentals-updated", this.refreshAppointments);
    window.removeEventListener("storage", this.handleStorageUpdate);
}

refreshAppointments() {
    this.setState({ data: this.buildAppointments(this.props) }, () => {
        this.appointmentForm.update();
    });
}

handleStorageUpdate(event) {
    if (event.key === "activeRentals") {
        this.refreshAppointments();
    }
}

handleAppointmentDoubleClick(appointment, defaultHandler, event) {
    if ((appointment?.type === "rental" || appointment?.type === "vehicle") && appointment?.link) {
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(appointment.link);
        return;
    }

    if (defaultHandler) {
        defaultHandler(event);
    }
}

componentDidUpdate(prevProps) {
    if (
        prevProps.events !== this.props.events
        || prevProps.rentalEventDurationMinutes !== this.props.rentalEventDurationMinutes
        || prevProps.rentalDeliveryEventDurationMinutes !== this.props.rentalDeliveryEventDurationMinutes
        || prevProps.rentalDeliveryWithSetupEventDurationMinutes !== this.props.rentalDeliveryWithSetupEventDurationMinutes
        || prevProps.rentalPickupEventDurationMinutes !== this.props.rentalPickupEventDurationMinutes
    ) {
        this.refreshAppointments();
    }
    this.appointmentForm.update();
}

onEditingAppointmentChange(editingAppointment) {
    this.setState({ editingAppointment });
}

onAddedAppointmentChange(addedAppointment) {
    this.setState({ addedAppointment });
    const { editingAppointment } = this.state;
    if (editingAppointment !== undefined) {
        this.setState({
            previousAppointment: editingAppointment,
        });
    }
    this.setState({ editingAppointment: undefined, isNewAppointment: true });
}

setDeletedAppointmentId(id) {
    this.setState({ deletedAppointmentId: id });
}

toggleEditingFormVisibility() {
    const { editingFormVisible } = this.state;
    this.setState({
        editingFormVisible: !editingFormVisible,
    });
}

toggleConfirmationVisible() {
    const { confirmationVisible } = this.state;
    this.setState({ confirmationVisible: !confirmationVisible });
}

commitDeletedAppointment() {
    this.setState((state) => {
        const { data, deletedAppointmentId } = state;
        const nextData = data.filter(appointment => appointment.id !== deletedAppointmentId);

        return { data: nextData, deletedAppointmentId: null };
    });
    this.toggleConfirmationVisible();
}

commitChanges({ added, changed, deleted }) {
    this.setState((state) => {
        let { data } = state;
        if (added) {
            const startingAddedId = data.length > 0 ? data[data.length - 1].id + 1 : 0;
            data = [...data, { id: startingAddedId, ...added }];
        }
        if (changed) {
            data = data.map(appointment => (
                changed[appointment.id] ? { ...appointment, ...changed[appointment.id] } : appointment));
        }
        if (deleted !== undefined) {
            this.setDeletedAppointmentId(deleted);
            this.toggleConfirmationVisible();
        }
        return { data, addedAppointment: {} };
    });
}

    render() {

        const Appointment = ({
            children, style, ...restProps
        }) => (
            <Appointments.Appointment
                {...restProps}
                onDoubleClick={(event) => this.handleAppointmentDoubleClick(restProps.data, restProps.onDoubleClick, event)}
                style={{
                    ...style,
                    backgroundColor: restProps.data.color,
                    borderRadius: '8px',
                }}
            >
                {children}
            </Appointments.Appointment>
        );


        const {
            data,
            confirmationVisible,
            editingFormVisible,
            startDayHour,
            endDayHour,
        } = this.state;
        return (
            <>
                <div className="mobileCalendar">
                    <Paper>
                        <Scheduler
                            data={data}
                            locale="fr-FR"
                            firstDayOfWeek={1}>
                            <ViewState />
                            <DayView
                                startDayHour={8}
                                endDayHour={22}
                            />
                            <EditingState
                                onCommitChanges={this.commitChanges}
                                onEditingAppointmentChange={this.onEditingAppointmentChange}
                                onAddedAppointmentChange={this.onAddedAppointmentChange}
                            />
                            <Toolbar />
                            <DateNavigator />
                            <Appointments
                                appointmentComponent={Appointment}
                            />
                            <AppointmentForm
                                overlayComponent={this.appointmentForm}
                                containerComponent={CalendarOverlayContainer}
                                visible={editingFormVisible}
                                onVisibilityChange={this.toggleEditingFormVisibility}
                            />
                            <AllDayPanel messages={{ allDay: "Journée" }} />
                            <Dialog
                                open={confirmationVisible}
                                onClose={this.cancelDelete}
                            >
                                <DialogTitle>
                                    Suppression
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText>
                                        Êtes-vous sûr de vouloir supprimer cet évènement ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.toggleConfirmationVisible} color="primary" variant="outlined">Annuler</Button>
                                    <Button onClick={this.commitDeletedAppointment} color="secondary" variant="outlined">Supprimer</Button>
                                </DialogActions>
                            </Dialog>
                        </Scheduler>
                    </Paper>
                </div>
                
                <div className="desktopCalendar">
                    <Paper>
                        <Scheduler
                            data={data}
                            locale="fr-FR"
                            firstDayOfWeek={1}>
                            <ViewState />
                            <EditingState
                                onCommitChanges={this.commitChanges}
                                onEditingAppointmentChange={this.onEditingAppointmentChange}
                                onAddedAppointmentChange={this.onAddedAppointmentChange}
                            />
                            <WeekView
                                startDayHour={startDayHour}
                                endDayHour={endDayHour}
                            />
                            <Toolbar />
                            <DateNavigator />
                            <Appointments
                                appointmentComponent={Appointment}
                            />
                            <AppointmentForm
                                overlayComponent={this.appointmentForm}
                                containerComponent={CalendarOverlayContainer}
                                visible={editingFormVisible}
                                onVisibilityChange={this.toggleEditingFormVisibility}
                            />
                            <AllDayPanel messages={{ allDay: "Journée" }} />
                        </Scheduler>
                        <Dialog
                            open={confirmationVisible}
                            onClose={this.cancelDelete}
                        >
                            <DialogTitle>
                                Suppression
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Êtes-vous sûr de vouloir supprimer cet évènement ?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.toggleConfirmationVisible} color="primary" variant="outlined">Annuler</Button>
                                <Button onClick={this.commitDeletedAppointment} color="secondary" variant="outlined">Supprimer</Button>
                            </DialogActions>
                        </Dialog>
                    </Paper>
                </div>
               
            </>


        );


    }
    
}
